// Phase DEMO-PROD.2D.1E — controlled credit / AI error mapping (French).
// Never surface backend exception text, provider details or DB errors.
export const CREDIT_ERROR_FR = {
  AI_PROVIDER_DISABLED: "L’assistant IA est temporairement désactivé.",
  AI_ACCESS_BLOCKED: "L’accès IA a été bloqué pour votre compte.",
  AI_ACCESS_STATUS_UNAVAILABLE: "Statut IA indisponible pour le moment. Réessayez plus tard.",
  SUBSCRIPTION_INACTIVE: "Aucun abonnement actif pour cette organisation.",
  AI_FEATURE_NOT_INCLUDED: "Cette action IA n’est pas incluse dans votre offre.",
  INSUFFICIENT_LODGE_CREDITS: "Crédits Lodge insuffisants pour cette action.",
  AI_COST_CONFIGURATION_UNAVAILABLE: "Action IA indisponible (configuration de coût manquante).",
  IDEMPOTENCY_KEY_REQUIRED: "Une clé d’idempotence valide est requise pour cette action.",
  AI_ACTION_IN_PROGRESS: "Cette action IA est déjà en cours de traitement.",
  CREDIT_OPERATION_CONFLICT: "Conflit sur l’opération de crédit. Réessayez avec une nouvelle action.",
};

// Resolve a stable error code from an axios error (top-level {error_code} or the
// X-AI-Error-Code header used by the provider-locked HTTPException path).
export function creditErrorCode(err) {
  const data = err?.response?.data;
  if (data && typeof data === "object" && data.error_code) return data.error_code;
  const hdr = err?.response?.headers?.["x-ai-error-code"];
  if (hdr) return hdr;
  return null;
}

export function creditErrorMessage(err, fallback = "Action IA indisponible.") {
  const code = creditErrorCode(err);
  return (code && CREDIT_ERROR_FR[code]) || fallback;
}
